/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateCallbackOutcome } from './CreateCallbackOutcome';
import {
    CreateCallbackOutcomeFromJSON,
    CreateCallbackOutcomeFromJSONTyped,
    CreateCallbackOutcomeToJSON,
    CreateCallbackOutcomeToJSONTyped,
} from './CreateCallbackOutcome';

/**
 * 
 * @export
 * @interface CreateCallbackResponse
 */
export interface CreateCallbackResponse {
    /**
     * 
     * @type {CreateCallbackOutcome}
     * @memberof CreateCallbackResponse
     */
    outcome: CreateCallbackOutcome;
}



/**
 * Check if a given object implements the CreateCallbackResponse interface.
 */
export function instanceOfCreateCallbackResponse(value: object): value is CreateCallbackResponse {
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    return true;
}

export function CreateCallbackResponseFromJSON(json: any): CreateCallbackResponse {
    return CreateCallbackResponseFromJSONTyped(json, false);
}

export function CreateCallbackResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallbackResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'outcome': CreateCallbackOutcomeFromJSON(json['outcome']),
    };
}

export function CreateCallbackResponseToJSON(json: any): CreateCallbackResponse {
    return CreateCallbackResponseToJSONTyped(json, false);
}

export function CreateCallbackResponseToJSONTyped(value?: CreateCallbackResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcome': CreateCallbackOutcomeToJSON(value['outcome']),
    };
}

